import { ApiResponse, postFetcher } from './base-api';
import type { ViewCountRequestParams } from './types/view.type';

/**
 * 페이지 접근 누계 등록
 * POST /v1/view-count
 * 미입력 필드는 '' 또는 null로 채워 전송함.
 */
export const postViewCount = async (
  body: ViewCountRequestParams,
): Promise<ApiResponse<null>> => {
  const payload = {
    type: body.type,
    hash: body.hash ?? '',
    location: body.location ?? '',
    uniqueKey: body.uniqueKey ?? null,
    academyId: body.academyId ?? null,
    alarmId: body.alarmId ?? null,
    entryId: body.entryId ?? null,
  };
  const res = await postFetcher<null, typeof payload>('/view-count', payload);
  return res;
};
